(function($){
    $(window).on('load', function(){
        checkNavigation();
    });

    $(window).resize(function(){
        checkNavigation();
    });

    function checkNavigation() {
        $('.soliloquy-theme-montage').each(function () {
            var $prev = $(this).find('.soliloquy-prev'),
                $next = $(this).find('.soliloquy-next');

            if (isShowNavigation($(this))) {
                $prev.addClass('d-none');
                $next.addClass('d-none');
            } else {
                $prev.removeClass('d-none');
                $next.removeClass('d-none');
            }
        });
    }

    function isShowNavigation($slider) {
        var navigationWidth = $slider.find('.soliloquy-prev').outerWidth(true) + $slider.find('.soliloquy-next').outerWidth(true),
            container = $slider.parents('.container');

        if (container.length) {
            var padding = container.innerWidth() - container.width(),
                emptySliderSpace = container.outerWidth(true) - container.innerWidth();

            return emptySliderSpace < navigationWidth + padding;
        }

        return window.innerWidth < $slider.width() + navigationWidth;
    }

}(jQuery));
